<template>
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <rect x="5.01294" y="5.01294" width="9.98389" height="9.98389" rx="1"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M2.5 10.5V2.5H10.5V3.47949H12V2C12 1.44772 11.5523 1 11 1H2C1.44772 1 1 1.44771 1 2V11C1 11.5523 1.44771 12 2 12H3.47949V10.5H2.5Z"/>
  </svg>
</template>

<style scoped lang="scss">
svg {
  width: 16px;
  height: 16px;

  rect, path {
    transition: all 0.2s ease;
    fill: #546F78;
  }

  &:hover {
    rect, path {
      transition: all 0.2s ease;
      fill: #85BAD3;
    }
  }
}
</style>